import { useSelector } from 'react-redux';
import { Country } from '../../models';
import { selectCountry } from '../../selectors';

export const useCountryById = (jurisdictionId: number): Country | undefined => {
  const country = useSelector(selectCountry(jurisdictionId));

  return country;
};
